import { CheckCircleFilled } from "@ant-design/icons"
import { Alert, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../Components/Button"

import styles from "../configure.module.less"

const { Text } = Typography

// Show the "we filled N fields from your-site.com" banner on whichever step
// the merchant lands on after a fresh scrape. Dismissable.
const AutofillBanner = ({ summary, onDismiss }) => {
  const { t } = useTranslation()
  if (!summary) return null

  if (!summary.ok) {
    const reason = (summary.errors && summary.errors[0]) || "Auto-fill skipped."
    return (
      <Alert
        type="warning"
        showIcon
        closable
        onClose={onDismiss}
        className={styles.autofillBanner}
        message={t("We couldn't read your website")}
        description={t(reason)}
      />
    )
  }
  const filledCount = (summary.filled || []).length
  const replacedCount = (summary.replaced || []).length
  const wipedCount = (summary.wiped || []).length
  const filledOrReplaced = filledCount + replacedCount
  if (filledOrReplaced === 0 && wipedCount === 0) {
    return (
      <Alert
        type="info"
        showIcon
        closable
        onClose={onDismiss}
        className={styles.autofillBanner}
        message={t("Nothing new from your site")}
        description={t(
          "We couldn't read anything fresh. Your homepage doesn't expose the metadata we look for. Fill these in manually below."
        )}
      />
    )
  }
  const site = (summary.site || "").replace(/^https?:\/\//, "")
  const one = filledOrReplaced === 1
  const headline =
    replacedCount > 0
      ? one
        ? t("Updated 1 field from _site_", { site })
        : t("Updated _n_ fields from _site_", { n: filledOrReplaced, site })
      : one
        ? t("Filled 1 field from _site_", { site })
        : t("Filled _n_ fields from _site_", { n: filledOrReplaced, site })
  return (
    <div className={`${styles.autofillBanner} ${styles.autofillBannerOk}`}>
      <div className={styles.autofillBannerIcon}>
        <CheckCircleFilled />
      </div>
      <div className={styles.autofillBannerBody}>
        <Text strong className={styles.autofillBannerTitle}>
          {headline}
        </Text>
        <Text type="secondary" className={styles.autofillBannerSub}>
          {wipedCount > 0
            ? wipedCount === 1
              ? t(
                  "Cleared 1 stale field from your previous URL. Review and refill anything you still need."
                )
              : t(
                  "Cleared _w_ stale fields from your previous URL. Review and refill anything you still need.",
                  { w: wipedCount }
                )
            : t(
                "We only fill what your homepage actually proves. Description, support contacts, logo, policy URLs. Everything else stays your call."
              )}
        </Text>
      </div>
      <Button type="default" className="compact-btn" onClick={onDismiss} text={t("Dismiss")} />
    </div>
  )
}

export default AutofillBanner
